import { DateInput, DateValue } from '@mantine/dates';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { queryParams } from 'utils/query';
import { generalDateFormat } from 'utils/dates';

interface Props {
  queryKey: string;
}

export const FilterBirthday = ({ queryKey }: Props) => {
  const { t } = useTranslation();
  const { setParameters, parameters: filters } = useSearchParameters(queryKey);

  const value = filters[queryParams.birthday] ? dayjs(+filters[queryParams.birthday]).toDate() : null;

  const handleChange = (date: DateValue) => {
    setParameters({
      ...filters,
      [queryParams.birthday]: date ? dayjs(date).startOf('day').valueOf().toString() : '',
    });
  };

  return (
    <DateInput
      locale={i18next.language}
      value={value}
      onChange={handleChange}
      valueFormat={generalDateFormat}
      placeholder={t('date_of_birth_label')}
      clearable
      defaultLevel={'decade'}
      defaultDate={dayjs().subtract(50, 'years').toDate()}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.currentTarget.blur();
        }
      }}
      data-testid={'input-filter-date-of-birth'}
    />
  );
};
